{
  "version": 1,
  "asset_id": "a698f622-dab2-4366-9285-95b85cd51e93",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a698f622-dab2-4366-9285-95b85cd51e93/bypass-normal-boxed-en-480.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a698f622-dab2-4366-9285-95b85cd51e93/bypass-normal-boxed-en-480.jpg",
  "original_filename": "bypass-normal-boxed-en-480.jpg",
  "size": 28476,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:08:50Z"
}
